import { fileURLToPath } from 'node:url'
import { defineNuxtModule } from '@nuxt/kit'

export default defineNuxtModule({
  meta: {
    name: 'biginUi',
    configKey: 'biginUi',
  },
  hooks: {
    'components:dirs': function (dirs: any) {
      dirs.push({
        path: fileURLToPath(new URL('./components', import.meta.url)),
        pattern: '*/index.mjs',
        prefix: 'b',
        ignore: ['{collection,slot,virtual-list}/index.mjs'],
      })
    },
  },
})

declare module '@nuxt/schema' {
  interface NuxtConfig {
    biginUi?: Record<string, unknown>
  }
  interface NuxtOptions {
    biginUi?: Record<string, unknown>
  }
}
